/**
 * Client-side search and sort for group lists.
 */
import type { Group, GroupSortOption } from '../types';

export const filterAndSortGroups = (
  groups: Group[],
  searchQuery?: string,
  sortOption?: GroupSortOption | string,
): Group[] => {
  let result = Array.isArray(groups) ? [...groups] : [];

  if (searchQuery?.trim()) {
    const q = searchQuery.toLowerCase().trim();
    result = result.filter((g) => (g.groupName || '').toLowerCase().includes(q));
  }

  switch (sortOption) {
    case 'newest':
      result.sort((a, b) => b.id.localeCompare(a.id));
      break;
    case 'members':
      result.sort((a, b) => b.totalMembers - a.totalMembers);
      break;
    case 'alpha_asc':
      result.sort((a, b) => (a.groupName || '').localeCompare(b.groupName || ''));
      break;
    case 'alpha_desc':
      result.sort((a, b) => (b.groupName || '').localeCompare(a.groupName || ''));
      break;
    default:
      break;
  }

  return result;
};

export const MY_GROUPS_PREVIEW_LIMIT = 4;
